// @ts-nocheck
import { v4 as uuidv4, validate as uuidValidate } from "uuid";
import VueCookies from "vue-cookies";
import moment from "moment-timezone";
import { getVueStore } from './vueInstance';
import { useToastStore } from '@modules/shared/stores/toast';
import { clearPreloadCacheStorage } from '@modules/app/composables/preloadCacheKeys';
import { resetAllPiniaStores } from './resetPiniaStores';
import i18n from '@/plugins/i18n';

export const isAuth = (window.location.pathname.includes("registration") || window.location.pathname.includes("login") || window.location.pathname.includes("forgot-password"));

export function transformDate(value) {
  const arr = value.split("/");
  const el = arr.shift();
  arr.splice(1, 0, el);
  return arr.join("/");
}

function resetStore() {
    const store = getVueStore();
    if (store) {
        store.commit("accounts/SET_ACCOUNTS", []);
        store.commit("accounts/SET_ACCOUNT_CURRENCIES", []);
        store.commit("payments/SET_PAYMENTS", []);
        store.commit("cards/SET_CARDS", []);
        store.commit("SET_CURRENT_USER", null);
    }
}

export function logout() {
	//ReInitChatWidget and clear User params
	if (typeof kw_event === 'function') {
		kw_event('kwreinitwidget', {
			user_id: '',
			params_from_site: {}
		})
	}
	VueCookies.remove("widget_user_data_cookie");
	//end ReInitChatWidget and clear User params

  removeRegistrationTokens();
  resetStore();
  // Purge the preloader's sessionStorage caches (survive reload + localStorage.clear)
  // and every in-memory Pinia store, so the next user can't see the previous user's data.
  clearPreloadCacheStorage();
  resetAllPiniaStores();
  VueCookies.remove("access_token");
  VueCookies.remove("auth_user_id");
  VueCookies.remove("entityId");
  VueCookies.remove("auth_refresh_token");
  VueCookies.remove("auth_refresh_token_expires");
}

export function removeRegistrationTokens() {
  VueCookies.remove("RegistrationToken");
  VueCookies.remove("Stage2RegistrationToken");
  VueCookies.remove("Stage3RegistrationToken");
  VueCookies.remove("Stage4RegistrationToken");
  localStorage.removeItem('registration_step3_data');
}

export function getAccessToken() {
  return VueCookies.get("access_token");
}

export function getUserId() {
  return VueCookies.get("auth_user_id");
}

export function getEntityId() {
  return VueCookies.get("entityId");
}

export function getRefreshToken() {
  return VueCookies.get("auth_refresh_token");
}

export function getAuthRefreshTokenExpirationDate() {
  // const currentDate = new Date();
  // return  new Date(currentDate.getTime() + 60000);
  return VueCookies.get("auth_refresh_token_expires");
}

export function getRegistrationToken() {
  return getAccessToken() || VueCookies.get("Stage2RegistrationToken") || VueCookies.get("RegistrationToken");
}

export function setAccessToken(access_token) {
  VueCookies.set("access_token", access_token, 60 * 60 * 24);
}

export function setEntityId(id) {
  VueCookies.set("entityId", id);
}

export function setAuthRefreshToken(refreshToken, expirationDate) {
  VueCookies.set(
    "auth_refresh_token",
    refreshToken,
    expirationDate || 60 * 60 * 24
  );
}

export function setAuthRefreshTokenExpirationDate(expirationDate) {
  VueCookies.set(
    "auth_refresh_token_expires",
    expirationDate,
    expirationDate || 60 * 60 * 24
  );
}

export function setAuthUserId(userId) {
  VueCookies.set(
    "auth_user_id",
    userId,
    60 * 60 * 24
  );
}

export function setRegistrationToken(token, step = 1) {
  const cookieName =
    step === 1
      ? 'RegistrationToken'
      : step === 4 || step === 5
      ? 'Stage3RegistrationToken'
      : step === 6
      ? 'Stage4RegistrationToken'
      : `Stage${step}RegistrationToken`;
  VueCookies.set(cookieName, token, 60 * 60 * 24);
}

export function removeRegistrationToken(step = 1) {
  const cookieName =
    step === 1
      ? 'RegistrationToken'
      : step === 4 || step === 5
      ? 'Stage3RegistrationToken'
      : step === 6
      ? 'Stage4RegistrationToken'
      : `Stage${step}RegistrationToken`;
  VueCookies.remove(cookieName);
}

export function transformObjectKeysToLowerCase(obj) {
  const newObj = {};
  Object.entries(obj).forEach(([key, value]) => {
    let newKey;
    if (key.includes(".")) {
      newKey = key.split(".").map((field) => field.charAt(0).toLowerCase() + field.slice(1)).join(".");
    } else {
      newKey = key.charAt(0).toLowerCase() + key.slice(1);
    }
    newObj[newKey] = value;
  });
  return newObj;
}

// export function transformCompanyDataForRequest(data) {
//   const finalData = { ...data };
//   finalData.companyType = transformTypeOfCompany(finalData.companyType);
//   if (finalData.companyStartDate) {
//     finalData.companyStartDate = moment(transformDate(finalData.companyStartDate)).format("YYYY-MM-DD");
//   }
//   return finalData;
// }

export function isExchangeAvailable() {
  const hour = moment(new Date()).tz("Europe/London").format("HH");
  return +hour < 18 && +hour >= 10;
}

export const accountRequisitesMapping = [
  { requisiteAttribute: "accountNumber", requisiteName: "Account Number" },

  { requisiteAttribute: "bankCode", requisiteName: "SORT Code" },

  { requisiteAttribute: "bankName", requisiteName: "Beneficiary Bank" },

  { requisiteAttribute: "beneficiaryName", requisiteName: "Beneficiary of Payment" },

  { requisiteAttribute: "beneficiaryAddress", requisiteName: "Beneficiary Address" }
];

export function getBrowserName(userAgent) {
  // The order matters here, and this may report false positives for unlisted browsers.

  if (userAgent.includes("Firefox")) {
    // "Mozilla/5.0 (X11; Linux i686; rv:104.0) Gecko/20100101 Firefox/104.0"
    return "Mozilla Firefox";
  }
  if (userAgent.includes("SamsungBrowser")) {
    // "Mozilla/5.0 (Linux; Android 9; SAMSUNG SM-G955F Build/PPR1.180610.011) AppleWebKit/537.36 (KHTML, like Gecko) SamsungBrowser/9.4 Chrome/67.0.3396.87 Mobile Safari/537.36"
    return "Samsung Internet";
  }
  if (userAgent.includes("Opera") || userAgent.includes("OPR")) {
    // "Mozilla/5.0 (Macintosh; Intel Mac OS X 12_5_1) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/104.0.0.0 Safari/537.36 OPR/90.0.4480.54"
    return "Opera";
  }
  if (userAgent.includes("Trident")) {
    // "Mozilla/4.0 (compatible; MSIE 7.0; Windows NT 10.0; WOW64; Trident/7.0; .NET4.0C; .NET4.0E; .NET CLR 2.0.50727; .NET CLR 3.0.30729; .NET CLR 3.5.30729)"
    return "Microsoft Internet Explorer";
  }
  if (userAgent.includes("Edge")) {
    // "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/58.0.3029.110 Safari/537.36 Edge/16.16299"
    return "Microsoft Edge (Legacy)";
  }
  if (userAgent.includes("Edg")) {
    // "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/104.0.0.0 Safari/537.36 Edg/104.0.1293.70"
    return "Microsoft Edge (Chromium)";
  }
  if (userAgent.includes("Chrome")) {
    // "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/104.0.0.0 Safari/537.36"
    return "Google Chrome or Chromium";
  }
  if (userAgent.includes("Safari")) {
    // "Mozilla/5.0 (iPhone; CPU iPhone OS 15_6_1 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/15.6 Mobile/15E148 Safari/604.1"
    return "Apple Safari";
  }
  return "unknown";
}

export function getPlatform(appVersion) {
  if (appVersion.indexOf("Win") !== -1) {
    return "Windows OS";
  }
  if (appVersion.indexOf("Mac") !== -1) {
    return "MacOS";
  }
  if (appVersion.indexOf("X11") !== -1) {
    return "UNIX OS";
  }
  if (appVersion.indexOf("Linux") !== -1) {
    return "Linux OS";
  }
  return "unknown platform";
}

export function debounce(func, delay) {
  let timerId;

  return function(...args) {
    if (timerId) {
      clearTimeout(timerId);
    }

    timerId = setTimeout(() => {
      func.apply(this, args);
      timerId = null;
    }, delay);
  };
}

export async function downloadBlob(blob, fileName) {
  console.log("downloadBlob");
  // Create a new blob with the same data as the original blob
  const newBlob = new Blob([blob], { type: blob.type });
  // Create a URL for the new blob
  const url = URL.createObjectURL(newBlob);

  // Create a link element to download the file
  const link = document.createElement("a");
  link.href = url;
  link.download = fileName || "document";
  // Click the link to start the download
  document.body.appendChild(link);
  link.click();

  // Clean up the URL object and link element
  URL.revokeObjectURL(url);
  document.body.removeChild(link);
}

export function getFileNameFromHeader(str) {
  console.log(str, "str");
  if (!str) {
    return null;
  }
  const regexp = /filename=["']([^"']+)/;
  const regexp2 = /filename=(.*?)(?:$|;|')/;
  const match = str.match(regexp) || str.match(regexp2);
  if (!match && !match?.length > 1) {
    return null;
  }
  return match[1];

}

export function areElementsInArray(firstArray, secondArray) {
  return firstArray.every(element => secondArray.includes(element));
}

export const companyTypesEnum = [
  {
    description: "Private Limited Company",
    id: 1
  },
  {
    description: "Sole Trade",
    id: 2
  },
  {
    description: "Limited Liability Partnership",
    id: 3
  },
  {
    description: "Joint Stock Company",
    id: 4
  },
  {
    description: "Others",
    id: 5
  }
];

function showCopiedToast(label) {
  try {
    const t = i18n?.global?.t?.bind(i18n.global);
    const text = label && t ? t('common.copiedItem', { item: label })
      : t ? t('common.copied')
      : label ? `${label} copied`
      : 'Copied';
    useToastStore().success(text);
  } catch (e) {
    console.error('Toast store not ready for copy notification', e);
  }
}

function fallbackCopy(text) {
  const el = document.createElement('textarea');
  el.value = text;
  el.setAttribute('readonly', '');
  el.style.position = 'absolute';
  el.style.left = '-9999px';
  document.body.appendChild(el);
  el.select();
  document.execCommand('copy');
  document.body.removeChild(el);
}

/**
 * Copy `text` to clipboard and show a success toast.
 * Pass `label` to show "{label} copied" (e.g. "IBAN"); otherwise shows generic "Copied".
 */
export async function copyToClipboard(text, label) {
  const value = text == null ? '' : String(text);
  if (!value) return;
  try {
    if (navigator?.clipboard?.writeText) {
      await navigator.clipboard.writeText(value);
    } else {
      fallbackCopy(value);
    }
  } catch {
    fallbackCopy(value);
  }
  showCopiedToast(label);
}

export function objectToTextWithColumns(obj, separator = "|", label) {
  const entries = Object.entries(obj);
  const column1Width = Math.max(...entries.map(([key]) => key.length));
  const column2Width = Math.max(...entries.map(([, value]) => value.toString().length));
  const text = entries.map(([key, value]) => `${key.padEnd(column1Width)} ${separator} ${value.toString().padEnd(column2Width)}`).join("\n");

  fallbackCopy(text);
  showCopiedToast(label);
}

export const defaultPaymentTemplate = {
  beneficiaryType: "Individual",
  type: "BankTransfer",
  bankCountry: null,
  currency: null
};

export const menuProps = {
  offsetY: true,
  nudgeBottom: 5,
  contentClass: "select-content"
};

export const menuPropsAutocomplete = {
    bottom: true,
    left: true,
    offsetY: true,
    nudgeBottom: 5,
    contentClass: 'select-content'
  };

export function filterAndSetPriorityToTemplateByCountry(arr) {
  const fields = arr.filter((item) => item.visible);
  fields.forEach((item) => {
    item.priority = 1;
    if (item.field === "Iban" || item.field === "AccountNumber") {
      item.priority = 3;
    } else if (item.field === "BankRoutingCode" || item.field === "BicSwift") {
      item.priority = 2;
    }
    item.field = transformFirstLetterToLowerCase(item.field);
    return item;
  });
  return fields.sort(sortByPriority);
}

export function sortByPriority(a, b) {
  if (a.priority > b.priority) {
    return -1;
  } else if (a.priority < b.priority) {
    return 1;
  } else {
    return 0;
  }
}

function transformFirstLetterToLowerCase(field) {
  return field.charAt(0).toLowerCase() + field.slice(1);
}

function transformFirstLetterToUpperCase(field) {
  return field.charAt(0).toUpperCase() + field.slice(1);
}

export function keysToLowerCase(obj) {
  const result = {};
  for (const key in obj) {
    if (Object.hasOwn(obj, key)) {
      // console.log("key", key.toUpperCase());
      result[transformFirstLetterToUpperCase(key)] = obj[key];
    }
  }
  return result;
}

export function copyMatchingFields(source, target) {
  for (const key in source) {
    // eslint-disable-next-line no-prototype-builtins
    if (Object.hasOwn(source, key) && target.hasOwnProperty(key)) {
      target[key] = source[key];
    }
  }
  return target;
}

export function deepEqual(obj1, obj2) {
  // Check if the objects are the same reference in memory
  if (obj1 === obj2) {
    return true;
  }

  // Check if the objects are both null or undefined
  if (obj1 == null || obj2 == null) {
    return obj1 === obj2;
  }

  // Check if the objects are not of the same type
  if (typeof obj1 !== typeof obj2) {
    return false;
  }

  // Check if the objects are primitive types
  if (typeof obj1 !== "object") {
    return obj1 === obj2;
  }

  // Check if the objects have the same number of properties
  const keys1 = Object.keys(obj1);
  const keys2 = Object.keys(obj2);
  if (keys1.length !== keys2.length) {
    return false;
  }

  // Recursively check each property value
  for (const key of keys1) {
    if (!deepEqual(obj1[key], obj2[key])) {
      return false;
    }
  }

  return true;
}

export function generateUniqueHash() {
  return uuidv4();
}

export const ibanPattern = /^[A-Z]{2}\d{2}[A-Z\d]{1,30}$/;
export function convertDate(iso) {
  // Assuming $moment is available globally or imported
  return (window).$moment(iso).utc().format("DD/MM/YYYY")
}
export function isEmptyUUID(uuid) {
  const emptyUUID = "00000000-0000-0000-0000-000000000000";
  return uuid === emptyUUID;
}
export function isValidUUID(uuid) {
  if (!uuid || typeof uuid !== 'string') {
    return false;
  }
  return uuidValidate(uuid) && !isEmptyUUID(uuid);
}

/** @deprecated Use `formatCurrency` from `@/utils/formatCurrency` instead */
export function formatAmount(value) {
  if (!value) return "0,00";

  // eslint-disable-next-line prefer-const
  let [integerPart, decimalPart] = value.toString().split(".");
  integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  if (!decimalPart) {
    decimalPart = "00";
  }
  return decimalPart ? `${integerPart},${decimalPart}` : integerPart;
}

/** @deprecated Use `formatCurrency` from `@/utils/formatCurrency` with `round: 'default'` instead */
export function roundToTwoDecimals(value) {
  return Math.round(value * 100) / 100;
}

export function parseAmount(value) {
  if (!value) return 0;
  // Remove spaces and replace comma with dot for parsing
  const cleanValue = value.toString().replace(/\s/g, '').replace(',', '.');
  const parsed = parseFloat(cleanValue);
  if (isNaN(parsed)) return 0;
  // Round to 2 decimal places
  return Math.round(parsed * 100) / 100;
}

// Common Latin ligatures/letters that Unicode NFD does not decompose to ASCII.
const LATIN_LIGATURES = {
  'ß': 'ss', 'ẞ': 'SS', 'æ': 'ae', 'Æ': 'AE', 'œ': 'oe', 'Œ': 'OE',
  'ø': 'o', 'Ø': 'O', 'ł': 'l', 'Ł': 'L', 'đ': 'd', 'Đ': 'D',
  'ð': 'd', 'Ð': 'D', 'þ': 'th', 'Þ': 'Th', 'ı': 'i',
};

// Keep text English/SWIFT-safe: transliterate accented Latin to base ASCII
// (José → Jose, Müller → Muller) and strip everything outside the allowed set
// — letters, digits, space, and the banking punctuation - . , / ' ( ) + &.
// Non-Latin scripts (e.g. Cyrillic) have no ASCII decomposition and are removed.
// Used for fiat beneficiary fields (name/address/city/bank/reference), which the
// banking backend rejects when they contain non-Latin or special characters.
export function sanitizeLatinText(value) {
  if (!value) return '';
  return String(value)
    .replace(/[ßẞæÆœŒøØłŁđĐðÐþÞı]/g, (ch) => LATIN_LIGATURES[ch] || ch)
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^A-Za-z0-9 .,\-/'()&+]/g, '');
}